import React from 'react'
// import ParentChildTables from '../../components/utils/parentChildTables'

const equipmentClass = ({roles}) => {
  return (
    <>
    {/*  <Table entityName={'equipmentClass'} /> */}
    {/* <ParentChildTables parentEntity={'Country'} childEntity={'Country'} rolePermissions={roles}/> */}
    </>
  )
}

export default equipmentClass